import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button, Switch } from 'antd';
import { TrainingProjectSessionModel } from '../../models';
import TrainingProjectSessionLogsList from './TrainingProjectSessionLogsList';
import './TrainingProjectSessionLogsModal.less';

interface Props {
    session?: TrainingProjectSessionModel;
    visible: boolean;
    onClose: () => void;
}

const TrainingProjectSessionLogsModal: React.FC<Props> = ({ session, visible, onClose }) => {
    const [autoScroll, setAutoScroll] = React.useState(true);

    return (
        <Modal
            className="alpha-portal-dialog training-project-session-logs-modal"
            bodyStyle={{ maxHeight: 'calc(100vh - 310px)' }}
            width={1000}
            visible={visible}
            title={
                <div className="logs-modal-header">
                    <span className="logs-title">Logs</span>
                    <div className="auto-scroll-controls">
                        <span className="auto-scroll-label">Auto scroll enabled</span>
                        <Switch checked={autoScroll} onChange={setAutoScroll} size="small" />
                    </div>
                </div>
            }
            onCancel={onClose}
            maskClosable={false}
            closable={false}
            centered
            footer={[
                <Button key="back" type="primary" onClick={onClose}>
                    Close
                </Button>
            ]}
        >
            {visible && session && (
                <TrainingProjectSessionLogsList
                    session={session}
                    autoScroll={autoScroll}
                    setAutoScroll={setAutoScroll}
                />
            )}
        </Modal>
    );
};

export default observer(TrainingProjectSessionLogsModal);
